<template>
  <div class="component">
     <el-icon class="close" size="16" color="#909399" @click="close">
        <Close />
      </el-icon>
    <div class="chart-box">
      <!-- <div class="header">2021-08</div> -->
      <div id="chartid-order-bike" class="chart"></div>
    </div>
    <div>
      <div style="font-weight: bold;font-size: 20px;margin-bottom: 30px;">仓号:{{chargeData.SlotId}}；电池ID：{{ chargeData.BatId }}</div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <div>曲线类型：</div><el-select class="opt" v-model="optval" placeholder="Select" style="width: 240px" @change="batteryOptions">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        />
      </el-select>
      </div>
    </div>
      
    
  </div>
</template>

<script>
// *   **电流 vs. 电压 (I-V) 曲线**：通常 **电压 (V)** 是 **横坐标 (X轴)**，**电流 (I)** 是 **纵坐标 (Y轴)**。
// *   **功率 vs. 电压 (P-V) 曲线**：通常 **电压 (V)** 是 **横坐标 (X轴)**，**功率 (P)** 是 **纵坐标 (Y轴)**。
import * as echarts from 'echarts'
import { onMounted, reactive,ref } from 'vue'
import axios from "axios"
import { toDay4 } from "@/common/func"
export default {
  name: 'OrderBike',
  props: {
    chargeList: {
      default: []
    }
  },
  setup (props, { emit }) {
    console.log(props.chargeList,'空数组')
    let myChart = null
    const formData = reactive({
    })
    let listData = []
    let chargeData = {SlotId:'',BatId:''}
    chargeData = props.chargeList[0]
    const initChart = () => {
      const chartDom = document.getElementById('chartid-order-bike')
      myChart = echarts.init(chartDom)
      batteryLevel()
    }
    const batteryLevel = async ()=>{
        // const params = {
        //     DevId:'ECBJRD1212XX20231229D8A8',
        //     BatId: 'BT204804812LDKJ230812285',
        //     SlotId:8
        // }
        // let res = await axios.get(`/admin/battery/batcurve`, {
        //   params
        // });
        listData.value = props.chargeList//res.List
        batteryOptions()
    }
    let optval = ref(1)
    let options = ref([
      {name:'电压电流',value:1},
      {name:'电量功率',value:2},
      {name:'电压功率',value:3},
    ])
    onMounted(() => {
      initChart()
    //   batteryLevel()
    })

    const batteryOptions = ()=>{
      console.log(optval.value,'切换的数值')
      if(optval.value == 1){
        let legend = ['电流']
        let xAxis = []
        let data = [[], []]
        let times = []            // 新增：时间数组，与 xAxis 同步索引
        for (let i = listData.value.length - 1; i >= 0; i--) {
          const rec = listData.value[i]
          rec.time = toDay4(rec.CreatedAt)
          xAxis.push(rec.Volt/10)            // 保持电压在横坐标
          times.push(rec.time|| '') // 根据字段替换
          data[0].push(rec.Curr/10)
        }

        // 注意：设置 axisLabel.interval 和 rotate 控制重叠
        const option = {
          title: { text: '电流电压' },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              // params[0] 为你的电流点
              const idx = params[0].dataIndex
              return `V: ${xAxis[idx]} <br/> Time: ${times[idx]} <br/> A: ${params[0].value}`
            }
          },
          legend: { data: legend },
          grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxis,
            name: 'V',
            nameLocation: 'end',
            axisLabel: {
              interval: 0,              // 显示所有标签（可改为数字或 'auto'）
              formatter: function (value, idx) {
                const t = times[idx] || ''
                // 用换行显示，或者用空格分行，避免过密可裁剪时间格式
                return t ? `${value}\n${t}` : value
              }
            },
            axisLabel: { rotate: 30 }  // 根据密集程度旋转避免重叠
          },
          yAxis: {
            type: 'value',
            name: 'A',
            nameLocation: 'end'
          },
          series: [{
            name: legend[0],
            type: 'line',
            lineStyle: { color: '#409EFF' },
            itemStyle: { color: '#409EFF' },
            data: data[0],
            // 可选：在每个点上显示时间会很拥挤
            // label: {
            //   show: true,
            //   formatter: function (params) { return times[params.dataIndex] },
            //   position: 'top',
            //   fontSize: 10
            // }
          }]
        }

        option && myChart.setOption(option)
      }else if(optval.value == 2){
        let legend = ['功率']
        let xAxis = []
        let data = [[], []]
        let times = [] 
        for (let i = listData.value.length - 1; i >= 0; i--) {
          const rec = listData.value[i]
          rec.time = toDay4(rec.CreatedAt)
          xAxis.push(rec.Soc)       
          times.push(rec.time|| '') 
          data[0].push(rec.Power/100)
        }

        const option = {
          title: { text: '充电功率' },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              // params[0] 为你的电流点
              const idx = params[0].dataIndex
              return `SOC: ${xAxis[idx]} <br/> Time: ${times[idx]} <br/> W: ${params[0].value}`
            }
          },
          legend: { data: legend },
          grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxis,
            name: 'SOC',
            nameLocation: 'end',
            axisLabel: {
              interval: 0,              // 显示所有标签（可改为数字或 'auto'）
              formatter: function (value, idx) {
                const t = times[idx] || ''
                // 用换行显示，或者用空格分行，避免过密可裁剪时间格式
                return t ? `${value}\n${t}` : value
              }
            },
            axisLabel: { rotate: 30 }  // 根据密集程度旋转避免重叠
          },
          yAxis: {
            type: 'value',
            name: 'W',
            nameLocation: 'end'
          },
          series: [{
            name: legend[0],
            type: 'line',
            lineStyle: { color: '#409EFF' },
            itemStyle: { color: '#409EFF' },
            data: data[0],
            // 可选：在每个点上显示时间会很拥挤
            // label: {
            //   show: true,
            //   formatter: function (params) { return times[params.dataIndex] },
            //   position: 'top',
            //   fontSize: 10
            // }
          }]
        }

        option && myChart.setOption(option)
      }else if(optval.value == 3){
        let legend = ['功率']
        let xAxis = []
        let data = [[], []]
        let times = [] 
        for (let i = listData.value.length - 1; i >= 0; i--) {
          const rec = listData.value[i]
          rec.time = toDay4(rec.CreatedAt)
          xAxis.push(rec.Volt/10)       
          times.push(rec.time|| '') 
          data[0].push(rec.Power/100)
        }

        const option = {
          title: { text: '电压功率' },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              // params[0] 为你的电流点
              const idx = params[0].dataIndex
              return `V: ${xAxis[idx]} <br/> Time: ${times[idx]} <br/> W: ${params[0].value}`
            }
          },
          legend: { data: legend },
          grid: { left: '3%', right: '4%', bottom: '10%', containLabel: true },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxis,
            name: 'V',
            nameLocation: 'end',
            axisLabel: {
              interval: 0,              // 显示所有标签（可改为数字或 'auto'）
              formatter: function (value, idx) {
                const t = times[idx] || ''
                // 用换行显示，或者用空格分行，避免过密可裁剪时间格式
                return t ? `${value}\n${t}` : value
              }
            },
            axisLabel: { rotate: 30 }  // 根据密集程度旋转避免重叠
          },
          yAxis: {
            type: 'value',
            name: 'W',
            nameLocation: 'end'
          },
          series: [{
            name: legend[0],
            type: 'line',
            lineStyle: { color: '#409EFF' },
            itemStyle: { color: '#409EFF' },
            data: data[0],
            // 可选：在每个点上显示时间会很拥挤
            // label: {
            //   show: true,
            //   formatter: function (params) { return times[params.dataIndex] },
            //   position: 'top',
            //   fontSize: 10
            // }
          }]
        }

        option && myChart.setOption(option)
      }
    }
    const close = () => {
      emit('close')
    }
    return {
      formData,
      optval,
      options,
      batteryOptions,
      close,
      chargeData
    }
  }
}

</script>

<style lang="scss" scoped>
  .component{
  position: absolute;
  z-index: 1100;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
    >.chart-box{
      position: relative;
      margin-top: 10%;
      >.header{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1000;
      }
      .chart{
        width: 100%;
        height: 22rem;
      }
    }
  }
.close{
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>
